import { render } from "./SalesCreate.vue?vue&type=template&id=365ed91a"
import script from "./SalesCreate.vue?vue&type=script&lang=js"
export * from "./SalesCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/RAREZA/mi-stock-rareza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__